import { compute } from "compute-scroll-into-view";
import { useCallback } from "react";
export const useScroll = (el, dataset = "data-index") => {
    return useCallback((index) => {
        const optionEl = el?.querySelector(`[role="option"][${dataset}="${index}"]`);
        if (optionEl && el) {
            scrollIntoView(optionEl, el);
        }
    }, [dataset, el]);
};
export const scrollIntoView = (node, menuNode) => {
    const actions = compute(node, {
        boundary: menuNode,
        block: "nearest",
        scrollMode: "if-needed",
    });
    actions.forEach((action) => {
        const { el, top, left } = action;
        el.scrollTop = top;
        el.scrollLeft = left;
    });
};
